/// <reference path="./vite-env.d.ts" />
import { z } from 'zod'

/**
 * Dashboard app environment variables
 * Uses Vite's import.meta.env (CARGO_ prefix)
 */
export const dashboardEnvSchema = z.object({
  CARGO_API_URL: z.string().url().default('http://localhost:3001'),
})

export type DashboardEnv = z.infer<typeof dashboardEnvSchema>

let _dashboardEnv: DashboardEnv | null = null

/**
 * Get validated dashboard environment.
 * Lazy-loaded to allow for runtime configuration.
 */
export function getDashboardEnv(): DashboardEnv {
  if (!_dashboardEnv) {
    _dashboardEnv = dashboardEnvSchema.parse(import.meta.env)
  }
  return _dashboardEnv
}

/**
 * Pre-validated dashboard environment.
 * Throws immediately on import if validation fails.
 */
export const dashboardEnv = dashboardEnvSchema.parse(import.meta.env)
